import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UigMarketplaceIconComponent } from './uig-marketplace-icon.component';
import { I18nModule } from '@spartacus/core';


@NgModule({
  imports: [
    CommonModule,
    I18nModule
  ],
  declarations: [
    UigMarketplaceIconComponent
  ],
  exports: [UigMarketplaceIconComponent],
})
export class UigMarketplaceIconModule { }
